import React, {useState, useEffect} from 'react';

import ic_left from 'image/ic_arrow_left.svg';
import ic_right from 'image/ic_arrow_right.svg';

const Pagenation = ({postsPerPage, totalPosts, paginate, currentPage, handlePageArrowClick, minPage, maxPage}) => {
  const [pageNumbers, setPageNumbers] = useState([]);

  useEffect(() => {
    let temp = [];
    for(let i=1; i<=Math.ceil(totalPosts/postsPerPage); i++){
      temp.push(i);
    }
    setPageNumbers(temp);
  }, [totalPosts, postsPerPage])

  


  return (
    <div className="wrap-pagenation Pagenation">
      <div className="con">
        <img src={ic_left} alt="icon left" className="btn-left btn-arrow" onClick={() => handlePageArrowClick(false)}/>
        <ul className="pagenation">
          {pageNumbers.map(number => {
           return number>=minPage && number<=maxPage 
            ?  <li className= {`btn-page ${currentPage===number ? `active` : ""}`} key = {number} onClick = {() => paginate(number)}>{number}</li>
            : ""
          })}
        </ul>
        <img src={ic_right} alt="icon right" className="btn-right btn-arrow" onClick = {() => handlePageArrowClick(true)}/>
      </div>
    </div>
  );
}

export default Pagenation;